import { Layout, Space, theme, Typography } from 'antd'
import { FC, PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'
import Menu from '../menu/menu'
import User from './user/user'

const { Header, Content } = Layout

const Logo = styled.img`
    display: block;
    height: 34px;
`

const HeaderStyled = styled(Header)<{ bg: string }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${p => p.bg};
`

const TitleStyled = styled(Typography.Title)`
    margin-bottom: 0 !important;
    margin-top: 0;
`

const ContentStyled = styled(Content)<{
    bg: string
}>`
    padding: 24px;
    margin: 0;
    min-height: 280px;
    background-color: ${p => p.bg};
`

interface PageLayoutProps {
    title?: ReactNode
    customTitle?: ReactNode
    scrollableContent?: boolean
    beforeUser?: ReactNode
}

const PageLayout: FC<PropsWithChildren<PageLayoutProps>> = ({
    title,
    customTitle,
    children,
    scrollableContent,
    beforeUser = null,
    // contentType,
}) => {
    const {
        token: { colorBgContainer },
    } = theme.useToken()

    return (
        <Layout style={{ height: '100%', flex: 1, minHeight: 0 }}>
            <HeaderStyled bg={colorBgContainer}>
                <Space size={24} align={'center'}>
                    <Logo src={'/logo-gamma.webp.png'} />
                    <TitleStyled>{title}</TitleStyled>
                </Space>
                <Space size={24} align={'center'}>
                    {beforeUser}
                    <User />
                </Space>
            </HeaderStyled>
            <ContentStyled
                bg={colorBgContainer}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 18,
                    overflowY: scrollableContent ? 'scroll' : 'hidden',
                }}
                id={'page-layout__content'}
            >
                {children}
            </ContentStyled>
            <Menu />
        </Layout>
    )
}

export default PageLayout

/* {customTitle ? (
        customTitle
    ) : (
        <Typography.Title style={{ paddingLeft: 24, margin: 0, width: '100%' }}>
            {title}
        </Typography.Title>
    )} */
